import Header from '../../components/layout/Header';
import OrderSummaryCheckoutCard from '@/components/checkout/order-summary/OrderSummaryCheckoutCard';
import CustomerCheckoutCard from '@/components/checkout/customer/CustomerCheckoutCard';
import PaymentCheckoutCard from '@/components/checkout/payment-method/PaymentMethodCheckoutCard';
import { useCancelOrder } from '@/hooks/use-cancel-order';
import usePollOrderValidation from '@/hooks/use-poll-order-validation';
import usePollPayment from '@/hooks/use-poll-payment';
import usePollOrderConfirmation from '@/hooks/use-poll-order-confirmation';

const Checkout = () => {
  const { cancel } = useCancelOrder();
  usePollOrderValidation();
  usePollPayment();
  usePollOrderConfirmation();

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        <Header variant="default" />

        <main className="grow">
          <div className="lg:relative lg:flex">
            <div className="px-4 sm:px-6 lg:px-8 py-8 lg:grow lg:pr-8 xl:pr-16 2xl:ml-[80px]">
              {/* Page content */}
              <div className="lg:max-w-[850px] lg:mx-auto">
                <header className="mb-8">
                  <div className="mb-5">
                    <button onClick={cancel} className="text-sm text-violet-500">
                      &lt;- Tillbaka till produkterna
                    </button>
                  </div>
                  <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Lägg beställning</h1>
                </header>
                <div className="mb-6 lg:mb-0 flex flex-col sm:flex-row gap-4 md:gap-8">
                  <div className="space-y-4 md:space-y-8 sm:w-1/2 md:w-3/5">
                    <CustomerCheckoutCard />
                    {/*  <PaymentCheckoutCard /> */}
                  </div>
                  <div className="sm:w-1/2 md:w-2/5">
                    <OrderSummaryCheckoutCard />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Checkout;
